import React, {useMemo, useEffect} from 'react';
import {Admin, Resource} from 'react-admin';
import {ErrorBoundary} from './components/ErrorBoundary';
import {CustomLoginPage} from './components/CustomLoginPage';
import {dataProvider} from './config/dataProvider';
import {authProvider} from './providers/authProvider';
import {clearRequestCache} from './utils/httpClient';
import {lightTheme, darkTheme} from './config/theme';
import {ContentList} from './components/lists/ContentList';
import {CategoryList} from './components/lists/CategoryList';
import {ContentTypeList} from './components/lists/ContentTypeList';
import {ContentCreate} from './components/forms/ContentCreate';
import {ContentEdit} from './components/forms/ContentEdit';
import {ContentShow} from './components/forms/ContentShow';
import {CategoryCreate} from './components/forms/CategoryCreate';
import {CategoryEdit} from './components/forms/CategoryEdit';
import {CategoryShow} from './components/forms/CategoryShow';
import {ContentTypeCreate} from './components/forms/ContentTypeCreate';
import {ContentTypeEdit} from './components/forms/ContentTypeEdit';
import {ContentTypeShow} from './components/forms/ContentTypeShow';
import {QuoteList} from './components/lists/QuoteList';
import {QuoteCreate} from './components/forms/QuoteCreate';
import {QuoteEdit} from './components/forms/QuoteEdit';
import {QuoteShow} from './components/forms/QuoteShow';
import ContentAnalyticsList from './components/analytics/ContentAnalyticsList';
import UserAnalyticsList from './components/analytics/UserAnalyticsList';
import {WaitList} from './components/lists/WaitList';

// Initialize API config (this runs the localStorage cleanup)
import './config/api';

const App = () => {
    // Clear request cache when component unmounts
    useEffect(() => {
        return () => {
            clearRequestCache();
        };
    }, []);

    const memoizedDataProvider = useMemo(() => dataProvider, []);
    const memoizedAuthProvider = useMemo(() => authProvider, []);

    return (
        <ErrorBoundary>
            <Admin
                dataProvider={memoizedDataProvider}
                authProvider={memoizedAuthProvider}
                loginPage={CustomLoginPage}
                requireAuth
                theme={lightTheme}
            >
                <Resource
                    name="content"
                    list={ContentList}
                    create={ContentCreate}
                    edit={ContentEdit}
                    show={ContentShow}
                />
                <Resource
                    name="content_analytics"
                    list={ContentAnalyticsList}
                    options={{label: 'Content Analytics'}}
                />

                <Resource
                    name="user_analytics"
                    list={UserAnalyticsList}
                    options={{label: 'User Analytics'}}
                />

                <Resource
                    name="categories"
                    list={CategoryList}
                    create={CategoryCreate}
                    edit={CategoryEdit}
                    show={CategoryShow}
                />

                <Resource
                    name="content_types"
                    list={ContentTypeList}
                    create={ContentTypeCreate}
                    edit={ContentTypeEdit}
                    show={ContentTypeShow}
                />

                <Resource
                    name="quotes"
                    list={QuoteList}
                    create={QuoteCreate}
                    edit={QuoteEdit}
                    show={QuoteShow}
                />
                <Resource name="waitlist"
                          list={WaitList}/>
            </Admin>
        </ErrorBoundary>
    );
};

export default App;

